/** * @Author: liujiannan * @Date: 2020-09-14 17:28:13 * @Description
门诊满意度调查 */
<template>
  <div class="satisfaction-view">
    <ph-empty v-if="isEmpty" />
    <div v-if="ftype === '1'" class="mainTabs">
      <div
        v-for="(tab, index) in dates"
        :key="index"
        :class="index === currentDate ? 'selected' : ''"
        @click="changeDate(index)"
      >
        {{ tab.name }}
      </div>
    </div>
    <ph-tabs
      v-if="ftype === '1'"
      v-model="currentSubIndex"
      :list="getSubList"
      @tabClick="changeSubitem"
      scrollable
    />
    <div class="title">
      <div>龙岩人民医院</div>
      <div>{{ questionName }}</div>
    </div>
    <div
      v-for="(group, groupId) in questionsList"
      :key="group.questionId"
      class="satisfaction-view-questions"
    >
      <div>{{ groupId + 1 }}、{{ group.questionDesc }}：</div>
      <!-- <div>
        请根据您本次门诊的真实体验，填写或选择您认为合适的选项：
      </div> -->
      <div
        v-for="(item, index) in group.children"
        :key="index"
        class="question-list-view"
      >
        <div class="question-title">
          {{ `${index + 1}、${item.questionDesc}` }}
        </div>
        <div v-if="item.fieldType === 'checkbox'">
          <van-checkbox-group v-model="answerList[item.questionId].fieldValue">
            <van-checkbox
              v-for="op in item.optionList"
              :key="op.optionId"
              :name="op.optionDesc"
              shape="square"
            >
              {{ op.optionDesc }}
            </van-checkbox>
          </van-checkbox-group>
        </div>
        <div v-if="item.fieldType === 'select'" @click="onShowSelect(item)">
          <van-field
            v-model="answerList[item.questionId].fieldValue"
            placeholder="请选择"
            disabled
          >
            <van-icon slot="right-icon" name="arrow-down" />
          </van-field>
        </div>
        <div
          v-if="item.fieldType === 'select6'"
          @click="
            showSelected6 = true;
            currentQuestionId = item.questionId;
          "
        >
          <van-field
            v-model="answerList[item.questionId].fieldValue"
            placeholder="请选择"
            disabled
          >
            <van-icon slot="right-icon" name="arrow-down" />
          </van-field>
        </div>
        <div
          v-if="item.fieldType === 'select10'"
          @click="
            showSelected10 = true;
            currentQuestionId = item.questionId;
          "
        >
          <van-field
            v-model="answerList[item.questionId].fieldValue"
            placeholder="请选择"
            disabled
          >
            <van-icon slot="right-icon" name="arrow-down" />
          </van-field>
        </div>
        <div v-if="item.fieldType === 'text'">
          <van-field
            v-model="answerList[item.questionId].fieldValue"
            placeholder="请输入"
          />
        </div>
        <div v-if="item.fieldType === 'textarea'">
          <van-field
            v-model="answerList[item.questionId].fieldValue"
            placeholder="请输入"
            type="textarea"
            rows="5"
          />
        </div>
        <div v-else>
          <div
            v-for="(question, qIndex) in item.children"
            :key="qIndex"
            class="question-content-item"
          >
            <div class="index-dot">
              {{ qIndex + 1 }}
            </div>
            <div class="question-content-item-answers">
              {{ question.questionDesc }}
              <div
                v-if="question.fieldType === 'select6'"
                @click="
                  showSelected6 = true;
                  currentQuestionId = question.questionId;
                "
              >
                <van-field
                  v-model="answerList[question.questionId].fieldValue"
                  placeholder="请选择"
                  disabled
                >
                  <van-icon slot="right-icon" name="arrow-down" />
                </van-field>
              </div>
              <div v-if="question.fieldType === 'select2'">
                <van-radio-group
                  v-model="answerList[question.questionId].fieldValue"
                  direction="horizontal"
                >
                  <van-radio name="是">是</van-radio>
                  <van-radio name="否">否</van-radio>
                </van-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ph-button
      @click="commit"
      class="satisfaction-view-commit"
      title="提交评价"
    />
    <!-- <div />提交评价</div> -->
    <van-popup v-model="showSelect" round position="bottom">
      <van-picker
        :columns="selectList"
        @cancel="showSelect = false"
        @confirm="onConfirm"
        show-toolbar
      />
    </van-popup>
    <van-popup v-model="showSelected6" round position="bottom">
      <van-picker
        :columns="select6List"
        @cancel="showSelected6 = false"
        @confirm="onConfirm6"
        show-toolbar
      />
    </van-popup>
    <van-popup v-model="showSelected10" round position="bottom">
      <van-picker
        :columns="select10List"
        @cancel="showSelected10 = false"
        @confirm="onConfirm10"
        show-toolbar
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showSelect: false,
      showSelected6: false,
      showSelected10: false,
      currentDate: 0,
      currentSubIndex: 0,
      dates: [],
      questionsList: [],
      questionName: "",
      selectList: [],
      select6List: [
        { text: "A、很满意", content: "很满意" },
        { text: "B、不太满意", content: "不太满意" },
        { text: "C、比较满意", content: "比较满意" },
        { text: "D、很不满意", content: "很不满意" },
        { text: "E、一般", content: "一般" },
        { text: "F、不了解", content: "不了解" }
      ],
      currentQuestionId: "",
      anserObject: {},
      answerList: null,
      ftype: "1",
      quesType: "01"
    };
  },
  computed: {
    getSubList() {
      if (this.dates.length > this.currentDate) {
        const subList = this.dates[this.currentDate].list;
        if (subList.length) {
          return subList.map(item => {
            return {
              name: `${item.officeName}-${item.doctorName}`,
              dataId: item.chargeSerialNo
            };
          });
        }
      }
      return [];
    },
    select10List() {
      const list = [];
      for (var i = 0; i <= 10; i++) {
        list.push({ text: `${i}分`, content: `${i}` });
      }
      return list;
    },
    isEmpty() {
      if (this.ftype === "1" && !this.dates.length) {
        return true;
      }
      if (this.ftype === "2" && !this.answerList) {
        return true;
      }
      return false;
    }
  },
  created() {
    this.ftype = this.$route.query.ftype || "1";
    this.quesType = this.$route.query.quesType || "01";
    if (this.ftype === "1") {
      this.loadData();
    } else {
      this.loadDetail();
    }
  },
  methods: {
    loadData() {
      this.$http
        .post(this.$api.OTHER_SATISFACTION_LIST, {
          functionType: this.ftype
        })
        .then(res => {
          this.dates = res.map(item => {
            return {
              name: item.chargeDate,
              list: item.daylist
            };
          });
          this.loadDetail();
        });
    },
    loadDetail() {
      var id = "";
      if (this.getSubList.length) {
        const { dataId } = this.getSubList[this.currentSubIndex];
        id = dataId;
      }
      this.$http
        .post(this.$api.OTHER_SATISFACTION_QUESTION, {
          functionType: this.ftype,
          type: this.quesType,
          dataId: id
        })
        .then(res => {
          if (res && res.questionList) {
            this.questionsList = res.questionList;
            this.answerList = this.getAnswerList(res.questionList);
            this.questionName = res.name;
            this.anserObject = {
              questionnaireId: res.questionnaireId,
              type: res.type,
              dataId: res.dataId
            };
          }
        });
    },
    changeDate(index) {
      this.currentDate = index;
      this.currentSubIndex = 0;
      this.loadDetail();
    },
    changeSubitem(_, index) {
      this.currentSubIndex = index;
      this.loadData();
    },
    onShowSelect(item) {
      this.showSelect = true;
      this.currentQuestionId = item.questionId;
      this.selectList = item.optionList.map(option => {
        return {
          text: option.fieldValue,
          content: option.fieldValue
        };
      });
    },
    onConfirm(value) {
      this.showSelect = false;
      if (this.currentQuestionId) {
        this.answerList[this.currentQuestionId].fieldValue = value.content;
      }
      this.currentQuestionId = "";
    },
    onConfirm6(value) {
      this.showSelected6 = false;
      if (this.currentQuestionId) {
        this.answerList[this.currentQuestionId].fieldValue = value.content;
      }
      this.currentQuestionId = "";
    },
    onConfirm10(value) {
      this.showSelected10 = false;
      if (this.currentQuestionId) {
        this.answerList[this.currentQuestionId].fieldValue = value.content;
      }
      this.currentQuestionId = "";
    },
    commit() {
      // console.log(this.answerList)
      const list = [];
      for (var index in this.answerList) {
        const item = this.answerList[index];
        if (item.need && !item.fieldValue.length) {
          this.$toast("请完整填写问题");
          return;
        }
        const value =
          item.fieldValue instanceof Array
            ? item.fieldValue.join(",")
            : item.fieldValue;
        list.push({
          fieldName: item.fieldName,
          questionId: item.questionId,
          fieldValue: value
        });
      }
      this.$http
        .post(this.$api.OTHER_SATISFACTION_QUESTION_SAVE, {
          functionType: this.ftype,
          ...this.anserObject,
          answerList: list
        })
        .then(() => {
          this.dates = [];
          this.questionsList = [];
          this.answerList = null;
          if (this.ftype === "1") {
            this.loadData();
          } else {
            this.loadDetail();
          }
        });
    },
    getAnswerList(questionList) {
      var result = {};
      for (var group of questionList) {
        const list = group.children;
        if (list && list.length) {
          for (var main of list) {
            const subList = main.children;
            if (subList && subList.length) {
              for (var subItem of subList) {
                result[subItem.questionId] = {
                  questionId: subItem.questionId,
                  fieldName: subItem.fieldName,
                  fieldValue: "",
                  need: subItem.notnull === "1"
                };
              }
            } else {
              if (main.fieldType === "checkbox") {
                result[main.questionId] = {
                  questionId: main.questionId,
                  fieldName: main.fieldName,
                  fieldValue: [],
                  need: main.notnull === "1"
                };
              } else {
                result[main.questionId] = {
                  questionId: main.questionId,
                  fieldName: main.fieldName,
                  fieldValue: "",
                  need: main.notnull === "1"
                };
              }
            }
          }
        }
      }
      return result;
    }
  }
};
</script>

<style lang="less" scoped>
.satisfaction-view {
  font-weight: 500;

  &-commit {
    margin: 2rem 1rem;
  }

  &-questions {
    margin: 0.5rem;
  }
}
.mainTabs {
  display: flex;
  width: 100%;
  height: 2.63rem;
  margin-top: 0.5rem;
  overflow-x: scroll;
  white-space: nowrap;
  background-color: #fff;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */

  > div {
    height: 2rem;
    margin: 0 0.5rem;
    padding: 0 0.8rem;
    color: black;
    font-weight: 400;
    font-size: 0.88rem;
    line-height: 2rem;
    text-align: center;
    background: #f5f5f5;
    border-radius: 0.2rem;
  }

  .selected {
    color: white;
    background: @primary-blue;
  }
}
.tabs::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.title {
  margin-top: 2rem;
  text-align: center;
}

.question-list-view {
  .question-title {
    margin: 1rem 0;
    padding: 0.5rem;
    color: white;
    background: @primary-blue;
    border-radius: 0.2rem;
  }

  .question-content-item {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    font-weight: 400;
    font-size: 0.88rem;

    .index-dot {
      flex-shrink: 1;
      width: 1.5rem;
      margin-right: 0.5rem;
      color: white;
      line-height: 1.5rem;
      text-align: center;
      background: @primary-blue;
      border-radius: 50%;
    }
    &-answers {
      width: 100%;
    }
  }
}
</style>

<style lang="less">
.satisfaction-view .van-field__body {
  width: 100%;
  font-size: 0.94rem;
  border-bottom: 1px solid gray;
}

.satisfaction-view .van-button__content {
  font-size: 0.94rem;
}

.satisfaction-view .van-field__control:disabled {
  color: black;
}
.satisfaction-view .van-checkbox {
  margin: 0.5rem;
}
.satisfaction-view .van-radio {
  margin-right: 5rem;
}
.satisfaction-view .van-checkbox__label {
  line-height: 1.4rem;
}
</style>
